import { AfterViewChecked, Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { Debounce } from '../decorators/debounce.decorator';

/**
 * Directive to collect a given property of HTMLElement children (including nested) with a given class name
 * e.g. can measure all child element heights, widths, etc.
 * Emits new values on window.resize event
 * 
 * Used on the scrollableHoldingsTable to measure row heights on the left table which can then be used to set heights on the right table
 * 
 * @export
 * @class MeasureChildElementsDirective
 * @implements {AfterViewChecked}
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[measure-child-elements]'
})
export class MeasureChildElementsDirective implements AfterViewChecked {
	// css class name of children to measure
	@Input() public querySelector: string;
	@Input() public propertyToMeasure: keyof HTMLElement; // An HTMLElement Property to measure e.g. offsetHeight
	@Input() public index?: number = 0; // index that can be used to track the group the items returned e.g. the asset class in scrollableHoldingsTable

	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() public onWindowResize: EventEmitter<{ index: number; elementMeasurements: Array<number> }> = new EventEmitter();

	constructor(private el: ElementRef) { }

	public ngAfterViewChecked(): void {
		this.measure(this.el.nativeElement, this.querySelector);
	}

	@HostListener('window:resize', ['$event'])
	@Debounce()
	public onResize(): void {
		this.measure(this.el.nativeElement, this.querySelector);
	}

	private measure(parent: HTMLElement, querySelector: string): void {
		if (parent) {
			const children: NodeList = parent.querySelectorAll(querySelector);
			if (children) {
				const elementMeasurements = Array.from(children).map((el: Node) => Number(el[this.propertyToMeasure]));
				this.onWindowResize.emit({ index: this.index, elementMeasurements });
			}
		}

	}
}
